import type { Skill } from '../types';

import { createAboutUsVideoSkill } from './createAboutUsVideo';
import { createAnimatedVideoSkill } from './createAnimatedVideo';
import { createBrandKitSkill } from './createBrandKit';
import { createFaqVideoSkill } from './createFaqVideo';
import { createFivePointListVideoSkill } from './createFivePointListVideo';
import { createHowToVideoSkill } from './createHowToVideo';
import { createMediaSlideshowVideoSkill } from './createMediaSlideshowVideo';
import { createPodcastWaveformVideoSkill } from './createPodcastWaveformVideo';
import { createProblemSolutionVideoSkill } from './createProblemSolutionVideo';
import { createProductAdVideoSkill } from './createProductAdVideo';
import { createSimilarToVideoSkill } from './createSimilarToVideo';
import { createVideoSkill } from './createVideo';
import { aiVoiceoverVideoBasicsSkill } from './aiVoiceoverVideoBasics';
import { changeTemplateSkill } from './changeTemplate';
import { cropMediaSkill } from './cropMedia';
import { documentBasicsSkill } from './documentBasics';
import { editVideoDuration } from './editVideoDuration';
import { findDamMediaSkill } from './findDamMedia';
import { findStockMediaSkill } from './findStockMedia';
import { findUserMediaSkill } from './findUserMedia';
import { gatherRequirementsSkill } from './gatherRequirements';
import { thirdPartyVideoLinkSkill } from './thirdPartyVideoLink';
import { fixTextWrappingSkill } from './fixTextWrapping';
import { motionGraphicsScenesBasicsSkill } from './motionGraphicsScenesBasics';
import { recordedVoiceoverVideoBasicsSkill } from './recordedVoiceoverVideoBasics';
import { reviewVideoSkill } from './reviewVideo';
import { talkingHeadVideoBasicsSkill } from './talkingHeadVideoBasics';
import { chartsBasicsSkill } from './chartsBasics';
import { textVideoBasicsSkill } from './textVideoBasics';
import { voiceoverVideoBasicsSkill } from './voiceoverVideoBasics';

// Re-exported so callers that need individual skills (the skill-routing eval's
// key map) can pull them from one module instead of 24 deep imports.
export * from './chartsBasics';
export * from './createAboutUsVideo';
export * from './createAnimatedVideo';
export * from './createBrandKit';
export * from './createFaqVideo';
export * from './createFivePointListVideo';
export * from './createHowToVideo';
export * from './createMediaSlideshowVideo';
export * from './createPodcastWaveformVideo';
export * from './createProblemSolutionVideo';
export * from './createProductAdVideo';
export * from './createSimilarToVideo';
export * from './createVideo';
export * from './aiVoiceoverVideoBasics';
export * from './changeTemplate';
export * from './cropMedia';
export * from './documentBasics';
export * from './editVideoDuration';
export * from './findDamMedia';
export * from './findStockMedia';
export * from './findUserMedia';
export * from './fixTextWrapping';
export * from './gatherRequirements';
export * from './motionGraphicsScenesBasics';
export * from './thirdPartyVideoLink';
export * from './recordedVoiceoverVideoBasics';
export * from './reviewVideo';
export * from './talkingHeadVideoBasics';
export * from './textVideoBasics';
export * from './voiceoverVideoBasics';

export const DEFAULT_SKILLS: Skill[] = [
    createVideoSkill,
    createAnimatedVideoSkill,
    createPodcastWaveformVideoSkill,
    createMediaSlideshowVideoSkill,
    createSimilarToVideoSkill,
    createProductAdVideoSkill,
    createFivePointListVideoSkill,
    createHowToVideoSkill,
    createFaqVideoSkill,
    createAboutUsVideoSkill,
    createProblemSolutionVideoSkill,
    changeTemplateSkill,
    gatherRequirementsSkill,
    findStockMediaSkill,
    findUserMediaSkill,
    findDamMediaSkill,
    voiceoverVideoBasicsSkill,
    aiVoiceoverVideoBasicsSkill,
    recordedVoiceoverVideoBasicsSkill,
    textVideoBasicsSkill,
    talkingHeadVideoBasicsSkill,
    documentBasicsSkill,
    thirdPartyVideoLinkSkill,
    chartsBasicsSkill,
    motionGraphicsScenesBasicsSkill,
    cropMediaSkill,
    editVideoDuration,
    fixTextWrappingSkill,
    reviewVideoSkill,
    createBrandKitSkill,
];
